import type { FluidFrictionPrerequisites, FluidProperties } from "../d";
import { OrkiszewskiFlowRegime } from "../../tubingFrictionLoss/orkiszewiski";

export function getFlowRegimeOrkiszewiski(
  flowRegimePrerequisites: FluidFrictionPrerequisites,
  fluidProperties: FluidProperties
) {
  const { mixSuperficialVelocityFTSEC, gasSuperficialVelocityFTSEC } =
    fluidProperties;
  const {
    inSituGasFlowRateCFS,
    inSituFluidFlowRateCFS,
    inSituLiquidFlowRateCFS,
    dimensionlessGasVelocity,
    noSlipLiquidHoldupLambdaCL,
    hydraulicDiameterFt
  } = flowRegimePrerequisites;

  // THESE SHOULD MOVE DOWN TO THE FLOW REGIME LEVEL
  const bubbleSlugBoundary = Math.max(
    0.13,
    1.071 - (0.2218 * mixSuperficialVelocityFTSEC ** 2) / hydraulicDiameterFt
  );

  // D211: =50+36*D207*D146/D149
  const slugTransitionBoundary =
    50 +
    (36 * dimensionlessGasVelocity * inSituLiquidFlowRateCFS) /
      inSituGasFlowRateCFS;

  // D213: =75+85*(D154*D146/D149)^(0.75)
  const transitionMistBoundary =
    (75 +
      85 *
        ((gasSuperficialVelocityFTSEC * inSituLiquidFlowRateCFS) /
          inSituGasFlowRateCFS)) **
    0.75;

  if (noSlipLiquidHoldupLambdaCL > 0.999) {
    return OrkiszewskiFlowRegime.LIQUID;
  } else if (
    inSituGasFlowRateCFS / inSituFluidFlowRateCFS <
    bubbleSlugBoundary
  ) {
    return OrkiszewskiFlowRegime.BUBBLE;
  } else if (
    inSituGasFlowRateCFS / inSituFluidFlowRateCFS > bubbleSlugBoundary &&
    dimensionlessGasVelocity < slugTransitionBoundary
  ) {
    return OrkiszewskiFlowRegime.SLUG;
  } else if (
    transitionMistBoundary > gasSuperficialVelocityFTSEC &&
    gasSuperficialVelocityFTSEC > slugTransitionBoundary
  ) {
    return OrkiszewskiFlowRegime.TRANSITION;
  } else if (dimensionlessGasVelocity > transitionMistBoundary) {
    return OrkiszewskiFlowRegime.MIST;
  } else {
    return OrkiszewskiFlowRegime.LIQUID;
  }
}
